module.exports = __webpack_public_path__ + "img/TORINO.b778fbc3.png";